export default __webpack_public_path__ + "static/media/img-0017.887b0ae2.png";